import { RecipientListUserModel } from "./RecipientListUser.model";

export class RecipientListUser extends RecipientListUserModel {
    // Add custom methods here
}
